import type { CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'

export const formSection: CSSObject = {
  paddingBlockStart: Spacing.M,
}

export const description: CSSObject = {
  inlineSize: '100%',
}

export const input: CSSObject = {
  'input:focus, input:hover, input:active, input:hover:not(:focus)': {
    backgroundColor: Color.light.Surface.N000,
  },
}

export const label: CSSObject = {
  color: Color.dark.Text.Default,
}

export const contentVariation: CSSObject = {
  borderBlockStartColor: Color.dark.Surface.N000,
  borderBlockStartWidth: 2,
  borderBlockStartStyle: 'solid',
  marginBlockStart: Spacing.XS * 5,
  paddingBlockEnd: Spacing.M,
}
